module.exports = __webpack_public_path__ + "img/samp1.f9d8fec6.png";